import React, { Component } from 'react'
import Select from 'react-select'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import {INTEGRATION_KEY} from "../../state/integration/Constants";

class TaxSelect extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            type: this.props.type || '',
            allTaxes: this.props.allTaxes || false,
            creatable: this.props.creatable || false,
            selectedOption: this.props.value || (this.props.tableTax ? this.props.tableTax.id : {}),
            mainTaxesOnly: !isNaN(this.props.mainTaxesOnly) ? this.props.mainTaxesOnly : true,
            tableTax: this.props.tableTax || null,
            multi: this.props.multi || false,
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        AppContext.getApiClient().get('/taxes').then(r => {
            let taxes = r.data
            if (!this.state.allTaxes) {
                taxes = this.getFilteredTaxes(taxes)
            }
            this.setState({
                options: taxes.map(t => {
                    return {
                        value: t.id,
                        label: t.attributes.name + ' (' + t.attributes.totalRate + '%)'
                    }
                })
            })
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            tableTax: nextProps.tableTax || null,
            mainTaxesOnly: !isNaN(nextProps.mainTaxesOnly) ? nextProps.mainTaxesOnly : true
        })
    }

    getFilteredTaxes(taxes) {
        const tableTaxLightspeedExternalLinks = this.state.tableTax ? this.state.tableTax.attributes.externalLinks.filter((link) => {
            return link.attributes.integrationKey === INTEGRATION_KEY.LIGHTSPEED_RETAIL
        }) : []
        let externalLightspeedTaxID = ''
        if (tableTaxLightspeedExternalLinks.length > 0) {
            externalLightspeedTaxID = tableTaxLightspeedExternalLinks[0].attributes.externalId
        }

        return taxes.filter(tax => {
            if (this.state.tableTax && tax.id === this.state.tableTax.id) {
                return true
            }
            for (let externalLink of tax.attributes.externalLinks) {
                const externalIDs = externalLink.attributes.externalId.split('_')
                // externalIDs[0] is taxCategory
                // externalIDs[1] is taxClass if length is longer than 1
                if (externalLink.attributes.integrationKey === INTEGRATION_KEY.LIGHTSPEED_RETAIL && externalIDs.length > 1) {
                    if (externalIDs[0] !== externalLightspeedTaxID) {
                        return false
                    }
                    return !this.state.mainTaxesOnly
                }
            }
            if (!externalLightspeedTaxID) {
                return true
            }
            return this.state.mainTaxesOnly
        })
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            if(selectedOption){
                if (this.state.multi === true) {
                    this.onChange(selectedOption.map(option => { return option.value }), selectedOption.map(option => { return option.label }).join(','))
                } else {
                    this.onChange(selectedOption.value, selectedOption.label)
                }
            }else{
                this.onChange("","")
            }
        });
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            tableTax: nextProps.tableTax,
        })
        if (nextProps.value !== this.state.selectedOption) {
            this.setState({
                selectedOption: nextProps.value || {}
            })
        }
    }

    render() {

        return (
            <Select
                name={this.name}
                multi={this.props.multi}
                placeholder={this.placeholder}
                value={this.props.value}
                onChange={this.handleChange}
                options={this.state.options}
                clearable={this.props.clearable || false}
            />
        )
    }
}

export default TaxSelect





// WEBPACK FOOTER //
// ./src/common/pricing/taxselect.component.jsx